import { isEmpty } from 'underscore';

import {
  ICountry,
  ICreateContactPayload,
  ICreateLeadPayload,
  ICreateOrderPayload,
  IInfoResult,
  PriceCountry,
} from '../../types/api';
import Api, { axiosInstance } from '../Api';

export default class BSApi {
  endPoint = 'BSApi';

  // Get Company size info
  async getCompanySizeInfo() {
    try {
      const response = await axiosInstance.get(
        `/${this.endPoint}/GetCompanySizeInfo`
      );
      const result: IInfoResult[] = response.data.Result.map((element: any) => {
        return {
          ...element,
          id: element.id.toString(),
        };
      });
      return result;
    } catch (error) {
      return [];
    }
  }

  // Get segments info
  async getSegmentsInfo() {
    try {
      const response = await axiosInstance.get(
        `/${this.endPoint}/GetSegmentsInfo`
      );
      if (isEmpty(response.data.Result)) {
        return [];
      } else {
        const result: IInfoResult[] = response.data.Result.map(
          (element: any) => {
            return {
              ...element,
              id: element.id.toString(),
            };
          }
        );
        return result;
      }
    } catch (error) {
      return [];
    }
  }

  // get price page country list
  // ! check out page also uses this api
  async getPriceCountryList() {
    const response = await axiosInstance.get(
      `/${this.endPoint}/GetCountryList`
    );
    if (isEmpty(response.data.Result)) {
      return [];
    } else {
      const result: ICountry[] = response.data.Result.value.map(
        (element: any) => {
          return {
            ...element,
            id: element.id.toString(),
            states: element.states.map((state: any) => {
              return { ...state, id: state.id.toString() };
            }),
          };
        }
      );
      return result;
    }
  }

  // After a new user is registered and activated, frontend need to call this API to create Lead.
  /*   async createLead(payload: ICreateLeadPayload){
    try {
      const response = await axiosInstance.post(`/${this.endPoint}/CreateLead?key=` + Api.API_KEY, payload);
      return response.data;
    } catch (error) {
      return({"Result":null,"Error": error})
    }
  } */

  // Get Contact for Checkout
  /*   async getContact(){
    try {
      const response = await axiosInstance.get(`/${this.endPoint}/GetContact?userId=` + Api.USER_NAME +`&key=` + Api.API_KEY);
      return response.data;
    } catch (error) {
      return({"Result":null,"Error": error})
    }
  } */

  /*     // Create Contact for Checkout if not exists
    // If Contact exists, ErrorMessage: "Conflict : Conflict"
    async createContact(payload: ICreateContactPayload){
      try {
        const response = await axiosInstance.post(`/${this.endPoint}/CreateContact?key=` + Api.API_KEY, payload);
        return response.data;
      } catch (error) {
        return({"Result":null,"Error": error})
      }
    } */

  /*   // Create order (in Business API)
    // Result includes paymentUrl that needs to be opened in a new tab/window. User will do the payment here.
    // For test payment, use card number 4242424242424242 and any other value for the rest.
    // From https://dhigroup.sharepoint.com/sites/wiki/SitePages/Getting-started-with-DHI-Payment-Gateway.aspx?web=1&CT=1620645830086&OR=OWA-NT&CID=fdd2ce13-4ecd-a7d2-910d-43afae0cf08f#%E2%80%8B%E2%80%8B%E2%80%8B%E2%80%8B%E2%80%8B%E2%80%8B%E2%80%8Bstep-2-order-processing-and-payment
    // You do not need to monitor closure of the window. User will be instructed to close the window and return to your web application.
    // There is no interaction needed with the window, since your backend API will be called when payment status changes.
    async createOrder(payload: ICreateOrderPayload){
      try {
        const response = await axiosInstance.post(`/${this.endPoint}/CreateOrder?key=` + Api.API_KEY, payload);
        return response.data;
      } catch (error) {
        return({"Result":null,"Error": error})
      }
    } */
}
